import { Component, OnInit } from '@angular/core';
import { I18nService } from '@sdk/services/i18n/i18n.service';
import { Icon } from '@types-custom/models/ui/icon-model';
import { TOptions } from 'i18next';

@Component({
  selector: 'not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent implements OnInit {
  icon = Icon.layer_traffic;

  constructor(
    private translator: I18nService
  ) { }

  get translate(): (key: string, params?: TOptions) => string | undefined {
    // ({archivo})
    return this.translator.getTranslator('app:page-not-found');
  }

  ngOnInit(): void {
    // ({directorio}, {archivo})
    this.translator.addFileToResourceBundle('app', 'app');
  }

}
